"use strict";

export default function blogFilter() {
    const section = document.getElementById("js-blog-section");
    if (!section) return;

    const filter = document.getElementById("js-blog-filter");
    const grid = document.getElementById("js-blog-grid");
    const skeleton = document.getElementById("js-blog-skeleton");
    const pagination = document.getElementById("js-blog-pagination");
    const pagesList = document.getElementById("js-pagination-pages");
    const prevBtn = document.getElementById("js-pagination-prev");
    const nextBtn = document.getElementById("js-pagination-next");

    const nonce = section.dataset.nonce || "";
    let currentCategory = 0;
    let currentPage = 1;
    let totalPages = parseInt(section.dataset.totalPages, 10) || 1;

    // Render initial pagination from server-side data
    renderPagination(totalPages, currentPage);

    function showSkeleton() {
        grid.style.display = "none";
        skeleton.style.display = "grid";
    }

    function hideSkeleton() {
        skeleton.style.display = "none";
        grid.style.display = "grid";
    }

    function renderPosts(posts) {
        grid.innerHTML = "";

        if (!posts.length) {
            grid.innerHTML =
                '<p class="p-blog__empty">Nenhum post encontrado.</p>';
            return;
        }

        posts.forEach((post) => {
            const article = document.createElement("article");
            article.classList.add("c-post");
            article.innerHTML = `
                <a href="${post.permalink}" class="c-post__image">
                    ${post.thumbnail ? `<img src="${post.thumbnail}" alt="${escapeHtml(post.title)}" loading="lazy">` : ""}
                </a>
                <div class="c-post__content">
                    <div class="c-post__text">
                        <a href="${post.permalink}">
                            <h3 class="c-post__title">${escapeHtml(post.title)}</h3>
                        </a>
                        <div class="c-post__excerpt">${escapeHtml(post.excerpt)}</div>
                    </div>
                    <a href="${post.permalink}" class="c-post__arrow" aria-label="Ler mais">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clip-path="url(#cp-ap)">
                                <path d="M7 17L17 7" stroke="#0056FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17 16V7H8" stroke="#0056FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="cp-ap">
                                    <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0 24)"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                </div>
            `;
            grid.appendChild(article);
        });
    }

    function renderPagination(total, current) {
        pagesList.innerHTML = "";

        if (total <= 1) {
            pagination.style.display = "none";
            return;
        }

        pagination.style.display = "flex";

        prevBtn.disabled = current <= 1;
        nextBtn.disabled = current >= total;

        const range = getPageRange(current, total);

        range.forEach((p) => {
            const li = document.createElement("li");
            li.classList.add("c-pagination__page");
            if (p === current) li.classList.add("c-pagination__page--active");

            if (p === "...") {
                li.innerHTML = `<span class="c-pagination__ellipsis">...</span>`;
            } else {
                const btn = document.createElement("button");
                btn.type = "button";
                btn.textContent = String(p).padStart(2, "0");
                btn.addEventListener("click", () =>
                    fetchPosts(currentCategory, p),
                );
                li.appendChild(btn);
            }

            pagesList.appendChild(li);
        });
    }

    function getPageRange(current, total) {
        if (total <= 7) {
            return Array.from({ length: total }, (_, i) => i + 1);
        }
        const pages = [];
        pages.push(1);
        if (current > 3) pages.push("...");
        for (
            let i = Math.max(2, current - 1);
            i <= Math.min(total - 1, current + 1);
            i++
        ) {
            pages.push(i);
        }
        if (current < total - 2) pages.push("...");
        pages.push(total);
        return pages;
    }

    function escapeHtml(str) {
        const div = document.createElement("div");
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    function fetchPosts(categoryId, paged) {
        showSkeleton();
        currentPage = paged;

        window
            .fetch(phpVars.ajaxUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams({
                    action: "filter_blog_posts",
                    nonce: nonce,
                    category_id: categoryId,
                    paged: paged,
                }),
            })
            .then((res) => res.json())
            .then((json) => {
                if (!json.success) return;
                totalPages = json.data.total_pages;
                renderPosts(json.data.posts);
                renderPagination(totalPages, currentPage);
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            })
            .catch(console.error)
            .finally(hideSkeleton);
    }

    // Filter tabs
    filter.addEventListener("click", (e) => {
        const tab = e.target.closest(".c-blog-filter__tab");
        if (!tab) return;

        filter
            .querySelectorAll(".c-blog-filter__tab")
            .forEach((t) => t.classList.remove("c-blog-filter__tab--active"));
        tab.classList.add("c-blog-filter__tab--active");

        currentCategory = parseInt(tab.dataset.category, 10) || 0;
        fetchPosts(currentCategory, 1);
    });

    // Prev / Next
    prevBtn.addEventListener("click", () => {
        if (currentPage > 1) fetchPosts(currentCategory, currentPage - 1);
    });

    nextBtn.addEventListener("click", () => {
        if (currentPage < totalPages)
            fetchPosts(currentCategory, currentPage + 1);
    });
}
